import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'p-icon-kit',
  templateUrl: './icon-kit.component.html',
  styleUrls: ['./icon-kit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconKitComponent implements OnInit {
  @Input() iconsMode = true;
  @Input() selectedItem: string;
  @Input() disabled = false;
  @Input() scheduleType: 'none' | 'typical' | 'individual' = 'none';
  @Output() selectedItemChange = new EventEmitter<string>();
  @Output() show: EventEmitter<any> = new EventEmitter();
  @Output() hide: EventEmitter<any> = new EventEmitter();

  constructor() { }

  public iconSet = [
    {label: 'DAILY', value: 'DAILY'},
    {label: 'WORKING_TIME', value: 'WORKING_TIME'},
    {label: 'NOT_WORKING_TIME', value: 'NOT_WORKING_TIME'},
    {label: 'DAY_TIME', value: 'DAY_TIME'},
    {label: 'NIGHT_TIME', value: 'NIGHT_TIME'},
    {label: 'YEAR_DAY', value: 'YEAR_DAY'}
  ];

  ngOnInit() {
    return;
  }

  /**
   * Устанавливает выбранное значение для внешних компонентов
   * @param {string} newValue
   */
  changeSelectedItem(newValue: {label: string; value: string}) {
    this.selectedItemChange.emit(newValue.value);
  }
}
